<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.title"
              :label="$t('form.title')"
              :readonly="disabledForm"
              outlined
              :rules="rules.fieldRequired"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-menu
              v-model="menu_date"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              :disabled="disabledForm"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="pressNew.date"
                  :label="$t('form.date')"
                  prepend-inner-icon="event"
                  readonly
                  outlined
                  v-on="on"
                  :rules="rules.fieldRequired"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="pressNew.date"
                @input="menu_date = false"
                :readonly="disabledForm"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col>
            <v-select
              v-model="pressNew.media_type"
              :items="media_types"
              :label="$t('form.pressNew.media_type')"
              :readonly="disabledForm"
              outlined
              :rules="rules.fieldRequired"
            ></v-select>
          </v-col>
          <v-col>
            <v-select
              v-model="pressNew.scope"
              :label="$t('form.pressNew.scope')"
              :items="scope_types"
              :readonly="disabledForm"
              outlined
              :rules="rules.fieldRequired"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.media"
              :label="$t('form.pressNew.media')"
              :readonly="disabledForm"
              outlined
              :rules="rules.fieldRequired"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="pressNew.uri"
              :label="$t('form.pressNew.uri')"
              :readonly="disabledForm"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
  
        <h5>{{ $t("form.files") }}</h5>
        <v-alert
          v-if="modOp_id === null"
          dense
          text
          type="info"
          class="without-margin-bottom"
        >
          {{ $t("form.publication.files.info") }}
        </v-alert>
        <v-card min-height="200px" elevation="0">
          <UploadFiles
            :read-only="disabledForm"
            object_type="news"
            :id="this.modOp_id"
            :final="false"
          />
          <v-row>
            <v-overlay
              :opacity="0.85"
              :absolute="true"
              :value="modOp_id === null"
              color="#ffffff"
            >
              <v-btn
                color="secondary"
                @click="saveform_trigger = !saveform_trigger"
              >
                {{ $t("button.saveForm") }}
              </v-btn>
            </v-overlay>
          </v-row>
        </v-card>

        <UserFormActions
          form_name_text="Modify pressNew"
          :form_name="form_name"
          :refForm="$refs.form"
          :saveform_trigger="saveform_trigger"
          :object_type="object_type"
          :data="processData"
          :state="state"
          @change-state="changeState"
          class="text-center mt-6"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import pressNew_data from "@/mixins/pressNew_data";
import pressNew_model from "@/mixins/model_utils/pressNew_model";
import UploadFiles from "../../reusables/UploadFiles";

export default {
  mixins: [changeState, validationRules, pressNew_data, pressNew_model],
  components: {
    RejectCommentLayout,
    UserFormActions,
    UploadFiles
  },

  data: () => ({
    form_name: "modifyPressNewForm",
    modOp_id: null,
    modOp_ip: null,
    menu_date: false,
    saveform_trigger: false,
    state: "",
    reject_comment: "",
    object_type: "news"
  }),

  watch: {
    $route() {
      this.modOp_id = Number(this.$route.params.id);
    }
  },

  created() {
    this.getScopeTypes();
    this.getMediaTypes();
    if (this.updatePressNewForm) {
      this.getData();
    } else {
      this.getPressNew(
        this.$store.state.endpoint + "/user/news/" + this.$route.params.id
      );
    }
  },

  computed: {
    updatePressNewForm() {
      return this.$route.params.id > -1 && !this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let data = {
        title: this.pressNew.title,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.pressNew.id,
        data: {
          user: {
            pressNew: {
              title: this.pressNew.title,
              date: this.pressNew.date,
              uri: this.pressNew.uri,
              scope: this.pressNew.scope,
              media: this.pressNew.media,
              media_type: this.pressNew.media_type,
            }
          }
        }
      };
      return data;
    }
  },

  methods: {
    getData() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/news/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.pressNew = response.data.data.user.pressNew;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.pressNew.id = response.data.object_id;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
